import type { FunctionComponent } from 'react';

interface EmailRestrictionsListProps {
  emailRestrictions: string[];
}

export const EmailRestrictionsList: FunctionComponent<
  EmailRestrictionsListProps
> = ({ emailRestrictions }) => {
  return (
    <ul>
      {Array.from(emailRestrictions).map((restriction, i) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <li key={i}>{restriction}</li>
      ))}
    </ul>
  );
};
